import WatchLayout from '../features/catalog/layouts/watch';

// TSS vite/01 — pages are thin; they mount a feature layout.
export default function WatchPage() {
    return <WatchLayout />;
}
